import React from 'react';
import { SvgIcon } from 'app/features/Icons/components';

const PlayIcon: React.FC = () => (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24">
        <path
            d="M8.992 3.986C8.68773 3.81219 8.34315 3.72138 7.99274 3.72265C7.64234 3.72393 7.29842 3.81724 6.99542 3.99324C6.69243 4.16925 6.44099 4.42177 6.26629 4.72552C6.09159 5.02927 5.99976 5.37359 6 5.724V18.276C5.99976 18.6264 6.09159 18.9707 6.26629 19.2745C6.44099 19.5782 6.69243 19.8307 6.99542 20.0068C7.29842 20.1828 7.64234 20.2761 7.99274 20.2773C8.34315 20.2786 8.68773 20.1878 8.992 20.014L19.976 13.736C20.2819 13.561 20.5361 13.3083 20.7129 13.0034C20.8898 12.6986 20.9829 12.3524 20.9829 12C20.9829 11.6476 20.8898 11.3014 20.7129 10.9966C20.5361 10.6917 20.2819 10.439 19.976 10.264L8.992 3.986Z"
            fill="currentColor"
        />
    </SvgIcon>
);

export default PlayIcon;
